export default __webpack_public_path__ + "static/media/pxgroup03.468b8433.png";